<template>
  <svg
    :width="width ? width : height ? height * (16 / 15) : 16"
    :height="height ? height : width ? width * (15 / 16) : 15"
    viewBox="0 0 16 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M5.2914.4202h-3.304C.9157.4202.0465 1.305.0465 2.3962l.037 8.7801a.64.64 0 0 0 .64.6373h1.631a.64.64 0 0 0 .64-.643L2.9577 3.384h3.1538a.4779.4779 0 0 0 .1325-.0186h3.0614l-.0397 4.8989H6.007c-.4233 0-.6435.5131-.3566.8293l4.7144 5.1997a.4798.4798 0 0 0 .7132 0l4.7144-5.1997c.2869-.3168.0661-.8293-.3566-.8293H12.177l.0397-5.8869c0-1.091-.8691-1.976-1.9408-1.976h-4.852a.4779.4779 0 0 0-.1325.0187z"
      :ill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'uturnright',
  props: {
    iconColor: {
      type: String,
      default: '#F94094',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
